import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { toast } from "react-toastify";


import { events } from "../../../../../redux/event/events/action";
import { selectEventsListItems } from "../../../../../redux/event/events/selector";
import { eventBookings } from "../../../../../redux/event/event-bookings/action";
import EventsDetailsModal from "../components/events-modal.component";
import EventsBookingModal from "../components/events-bookings-modal.component";
import { tickets } from "../../../../../redux/tickets/action";
import Popup from "../../../../../common/components/popup";


export const AvailableEvents = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [dbaasProgram, setDBaasProgram] = useState<any[]>([]);
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const eventsItems = useSelector(selectEventsListItems);
  const image = require('../../../../../assets/img/image 1.png');
  const [selectEvents, setSelectEvents] = useState<any>({});
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [addItem, setAddItem] = useState<any>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);

  useEffect(() => {
    dispatch(events.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/list`,
      entity: 'events',
      jsonData: {
      }
    }));
  }, [dispatch]);

  const fetchEventsList = () => {
    dispatch(events.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/list`,
      entity: 'events',
      jsonData: {
      }
    }));
  };

  useEffect(() => {
    setDBaasProgram(eventsItems?.result?.items || []);
  }, [eventsItems]);



   const handleSubscribe = async (data: any) => {
  console.log('Booking Data:', data);
  await dispatch(eventBookings.resetAction({ actionType: 'create' }));
  await dispatch(eventBookings.create({
    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/bookings`,
    entity: 'eventBookings',
    jsonData: {
      Context: {
        Subscription: "ONE",
        Domain: "ONE",
        SubDomains: [],
        Network: "ONEUser",
        Application: "ONEUser",
        Channel: "CSP"
      },
      Records: [
        {
          EventId: data.EventId,
          EventTicketId: data.Id, // Ticket ID
          Quantity: data.quantity,
          IsExistingUser: true,
          OwnerType: "Events"
        }
      ]
    }
  })).then(() => {
   
    fetchEventsList(); // Refresh list
  });
};


  const handleDetails = (events: any) => {
    setSelectEvents(events);
    setShowDetailsModal(true);
  };

  const closeModal = () => {
    setShowDetailsModal(false);
    setSelectEvents({});
  };

  // Handle Booking Modal
  const handleBookings = async (events: any) => {
  setSelectEvents(events);

  // First fetch tickets
  await dispatch(tickets.list({
    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/list`,
    entity: 'tickets',
    jsonData: {
      Filters: [
        {
          FieldName: 'EventId',
          FilterOperatorId: 1,
          FieldValue: events?.EventId,
          FieldType: 'number'
        }
      ]
    }
  }));

  // THEN show the modal
  setShowBookingModal(true);
};

  const closeModalBooking = () => {
    setShowBookingModal(false);
    setSelectEvents({});
  };

  // Details Modal Component
  const NewItemPopup = () => (
    <Popup onClose={closeModal}>
      <EventsDetailsModal Close={closeModal} selectEvents={selectEvents} />
    </Popup>
  );

  // Booking Modal Component
 const NewBookingItemPopup = () => (
  <Popup onClose={closeModalBooking}>
    <EventsBookingModal
      Close={closeModalBooking}
      selectEvents={selectEvents}
      onInnerBasicFormChange={(data) => {
        // Call handleSubscribe
        handleSubscribe({ ...data, EventId: selectEvents?.EventId });
        closeModalBooking(); // close modal after booking
      }}
    />
  </Popup>
);
  
  

  return (
    <>
      {showDetailsModal && <NewItemPopup />}
      {showBookingModal && <NewBookingItemPopup />}

      <div className="min-h-screen bg-red px-4 py-6">
        <div className="max-w-7xl mx-auto">

          <h2 className="text-center text-xl md:text-2xl font-bold text-gray-800 mb-6">
            Available Events
          </h2>

          {dbaasProgram.length === 0 ? (
            <div className="text-center text-gray-600 text-md">
              No available communities to show.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {dbaasProgram.map((events, index) => (
                <div
                  key={events?.Id || index}
                  className="flex flex-col border border-gray-300 rounded-lg bg-gray-50 hover:border-gray-500 hover:shadow-md transition-transform hover:scale-105 p-3"
                >
                  <div className="relative w-full">
                    <div className="w-full h-0 pb-[60%] bg-zinc-200 rounded-md overflow-hidden">
                      <img
                        className="absolute inset-0 w-full h-full object-contain"
                        src={events?.CoverImageUrl || image}
                        alt={events?.Name || "Subscription Image"}
                      />
                    </div>
                  </div>

                  <div className="mt-2 text-sm text-center">
                    <div className="font-semibold text-black truncate">{events?.Name}</div>

                  </div>

                  <div className="mt-3 flex gap-3">
                    <button
                      className="bg-blue-600 w-40 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-md flex items-center transition duration-200 shadow hover:shadow-lg"
                      onClick={() => handleDetails(events)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="mr-2">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                      More Details
                    </button>

                    <button
                      className="bg-green-600 w-40 hover:bg-green-700 text-white text-sm px-4 py-2 rounded-md flex items-center transition duration-200 shadow hover:shadow-lg"
                      onClick={() => handleBookings(events)}
                    // onClick={() => handleSubscribe(events)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="mr-2">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                      Booking
                    </button>
                  </div>

                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );

};






